export default {
    messages: {
        "navbar.links.discover": "À PROPOS DE UBISOFT+",
        "navbar.links.store": "Store",
        "navbar.links.news": "Actualités",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "Support",
        "navbar.links.status": "Mon statut",
        "navbar.links.featured": "En vedette",
        "navbar.links.rewards": "Récompenses",
        "navbar.links.library": "Tous les jeux",
        "navbar.links.benefits": "Programme de fidélité",
        "navbar.links.subscription": "Gérer mon abonnement",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Tous les jeux",
        "heading.my_games": "Continuez à jouer",
        "heading.popular_games": "Jeux les plus joués",
        "heading.recommended_games": "Recomandé pour vous",
        "action.load_more_games": "Charger plus de jeux",
        "action.search_for_game": "Chercher un jeu",
        "action.launch_game": "Lancer le jeu",
        "action.activate_game": "Activer le jeu",
        "filters.brand": "Marques",
        "filters.game_name": "A - Z",
        "filters.release_date": "Date de sortie",
        "filters.show_all": "Afficher tous",
        "filters.sort": "Trier par",
        "filters.all": "Tout",
        "filters.activated": "Activés",
        "message.no_activated_games": "Aucun jeu ne correspond à votre recherche",
        "message.already_owned": "Vous possédez déjà ce jeu",
        "message.no_available_games": "Aucun jeu ne correspond à votre recherche",
        "message.no_search_results": "Aucun jeu ne correspond à votre recherche",
        "message.error": "Oups ! Une erreur est survenue lors du traitement de votre demande",
        "message.refresh_page": "Veuillez cliquer ici pour réessayer",
        "message.no_subscription": "Vous n'avez pas d'abonnement actif",
        "warning.savefiles_alert.title": "Message important concernant la sauvegarde de fichiers",
        "warning.savefiles_alert.body": "La mise à niveau vers l'édition disponible sur UBISOFT+ affectera vos fichiers de sauvegarde, y compris votre progression actuelle dans le jeu. Si votre abonnement UBISOFT+ prend fin, vous devrez acheter le Season Pass pour charger l’un de vos fichiers de sauvegarde (y compris votre progression actuelle dans le jeu). Pour plus d'informations, veuillez consulter les articles {here}.",
        "warning.savefiles_alert.body.here": "ici",
        "warning.savefiles_alert.cancel": "Retour",
        "warning.savefiles_alert.confirm": "Valider",
        "warning.mobile_launch_alert.body": "{game} a été ajouté à votre bibliothèque de jeux. Lancez Uplay pour jouer.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "CONDITIONS D'UTILISATION",
        "footer.links.privacy_policy_label": "POLITIQUE DE CONFIDENTIALITÉ",
        "footer.links.legal_label": "MENTIONS LEGALES",
        "hero.title": "Service d'abonnement Ubisoft",
        "hero.subtitle": "ACCÈS ILLIMITÉ À + DE 100 JEUX | Annulez à tout moment",
        "hero.buttons.subscribe": "Abonnez-vous dès maintenant",
        "hero.buttons.login": "Se connecter",
        "hero.buttons.browse": "Voir tous les jeux",
        "progression.benefits.description": "Débloquez nos mondes et conquérez les vôtres. Nous récompensons votre fidélité ! Chaque mois, obtenez de nouvelles récompenses in-game.\r\nPlus vous restez sur Ubisoft+, plus vous obtenez de récompenses in-game !",
        "progression.benefit.singular.reward": "récompense",
        "progression.benefit.plural.reward": "récompenses",
        "progression.benefit.singular.benefit": "avantage",
        "progression.benefit.plural.benefit": "avantages",
        "progression.benefit.singular.booster": "booster",
        "progression.benefit.plural.booster": "boosters",
        "progression.level.subscribed_for": "Abonné depuis",
        "progression.level.new_subscriber": "Nouveau abonné",
        "progression.level.new_subscribers": "Nouveaux abonnés",
        "progression.level.subscription.first_month": "1 mois",
        "progression.level.subscription.starting_with_months": "{months} mois",
        "general.date.month": "mois",
        "general.date.months": "mois",
        "general.date.month_remaining": "mois restant",
        "general.date.months_remaining": "mois restants",
        "rewards.monthly_rewards": "Vos récompenses mensuelles",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} restant(e)s pour récupérer vos {rewards_left} récompense(s) du mois",
        "rewards.current_title": "Récompenses du mois",
        "rewards.previous_title": "Récompenses passées",
        "rewards.upcoming_title": "Récompenses à venir",
        "rewards.none_found": "Aucune récompense trouvée",
        "rewards.available": "Disponible",
        "rewards.locked": "Verrouillé",
        "rewards.claimed": "Récupéré",
        "rewards.claim": "Oui",
        "rewards.cancel": "Annuler",
        "rewards.confirm": "Voulez-vous récupérer cette récompense?",
        "rewards.none_left": "Vous n'avez plus de récompenses à récupérer",
        "rewards.already_claimed": "Vous avez déjà récupéré cette récompense",
        "rewards.claim_confirm": "Cette récompense est désormais disponible dans votre jeu ! ",
        "rewards.close": "Fermer",
        "rewards.load_more": "Charger plus",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "Plus d'informations",
        "external.links.actions.learn_more": "Apprendre encore plus"
    }
};